import React, {  createContext, useContext, useState } from "react";
import grapesjs from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import axios from "axios";
import qs from "qs";
import Fonts from '../components/Fonts'
import Devices from "../components/Devices";
import myRuler from "grapesjs-rulers";

import blockAdvance from "grapesjs-blocks-avance";
import blocksBasic from "grapesjs-blocks-basic";
import myExport from "grapesjs-plugin-export";
import { ContacComponent,Deneme,ImageWithIcon } from "../components/Components";
import editorTool from "grapesjs-rte-extensions";
import ckEditor from "grapesjs-plugin-ckeditor";
import '../css/Contact.css'
import hekcss from "../css/Hekeditor.css";
//import carouselplugin from "grapesjs-plugin-carousel";
import loryslide from 'grapesjs-lory-slider'

const mPlugin = [
    myRuler,
    editorTool,
    'gjs-blocks-basic',
    myExport,
    ContacComponent,
      //loryslide,
      ImageWithIcon,

      Deneme
    ]
const mpOptions = {

    assetManager: {
      
    }, 
    myRuler: { /* options */ },
    [editorTool]: {
        list: false,
        darkColorPicker: true,
        extra: false,
        base: {
            bold: true,
            italic: true,
            underline: true,
            strikethrough: true,
            link: false,
            font: true,
        },
        fonts: {
            fontName: [
                "aachenn",
                "Ab -thar",
                "AdventPro-Medium",
                "adwa-assalaf B",
                "adwa-assalaf",
                "AkayaKanadaka-Regular",
                "AkzidenzGrotesk-ExtraBold",
                "AkzidenzGrotesk-ExtraBoldCond",
                "AkzidenzGrotesk-UltraBoldCond",
                "AkzidenzGroteskPro-Bold",
                "AkzidenzGroteskPro-It",
                "AkzidenzGroteskPro-Light",
                "AkzidenzGroteskPro-LightCn",
                "AkzidenzGroteskPro-LightIt",
                "AkzidenzGroteskPro-Md",
                "AkzidenzGroteskPro-MdIt",
                "AkzidenzGroteskPro-Regular",
                "Al Tarikh",
                "AlHurraTxtBold",
                "AlHurraTxtreg",
                "AlianzaSlab100",
                "AlianzaSlab200",
                "AlianzaSlab300",
                "AlianzaSlab400",
                "AlianzaSlab500",
                "AlianzaSlab600",
                "AlianzaSlab700",
                "AlianzaSlab800",
                "AlianzaSlab900",
                "alletha-Regular",
                "Allura-Regular",
                "Altrincham W01 Oblique",
                "Altrincham-Bol",
                "Altrincham-Reg",
                "AlwaysForever-Bold",
                "AmericanTypewriter",
                "AnnieUseYourTelescope",
                "Arabic Symbols 01",
                "Arial Black",
                "arial",
                "AThuluth",
                "Audiowide-Regular",
                "Authenia",
                "Avenir Next",
                "Axiforma-Black",
                "Axiforma-Bold",
                "Axiforma-Medium",
                "Axiforma-Regular",
                "Axiforma-SemiBold",
                "Axiforma-Thin",
                "Barlow-Bold",
                "Barlow-Italic",
                "Barlow-Regular",
                "Baro-Plain",
                "BauerB",
                "Bellevue",
                "berlingi",
                "Bickham2",
                "billy-bold",
                "billy-semibold",
                "Blur",
                "BrandonGrotesque-Bold",
                "Butler_Ultra_Light_Stencil",
                "CambayDevanagari",
                "Cera Pro Black",
                "Cera Pro Bold Italic",
                "Cera Pro Bold",
                "Cera Pro Light Italic",
                "Cera Pro Light",
                "Cera Pro Medium",
                "Cera Pro Regular Italic",
                "CeraPro-Black",
                "CeraPro-BlackItalic",
                "CeraPro-Bold",
                "CeraPro-Italic",
                "CeraPro-Light",
                "CeraPro-MediumItalic",
                "CeraPro-Regular",
                "CgTower-CondensedRegular",
                "ChronicleDispCond-Roman",
                "COCOGOOSELETTERPRESS",
                "Colby-CdBlk",
                "Colby-CdMed",
                "Colby-CpBlk",
                "Colby-CpReg",
                "Colby-StBld",
                "Colby-StBlk",
                "Colby-StMed",
                "Colby-StReg",
                "CoolveticaCondensedRg-Regular",
                "CoolveticaRg-Regular",
                "Damascus",
                "DecoTypeNaskh",
                "Didot",
                "DIN-Bold",
                "DIN-LightItalic",
                "DIN-MediumItalic",
                "DIN-Medium_0",
                "DINT",
                "DINTBold",
                "DINTMedium",
                "Exo-Bold",
                "GeezaPro",
                "Georgia Italic",
                "Georgia",
                "GloriaHallelujah",
                "GreatVibes-Regular",
                "HelveticaNeue",
                "HelveticaNeueLTPro-Bd",
                "HelveticaNeueLTPro-BdCn",
                "HelveticaNeueLTPro-BdCnO",
                "HelveticaNeueLTPro-BdEx",
                "HelveticaNeueLTPro-BdExO",
                "HelveticaNeueLTPro-BdIt",
                "HelveticaNeueLTPro-BdOu",
                "HelveticaNeueLTPro-Blk",
                "HelveticaNeueLTPro-BlkCn",
                "HelveticaNeueLTPro-BlkCnO",
                "HelveticaNeueLTPro-BlkEx",
                "HelveticaNeueLTPro-BlkExO",
                "HelveticaNeueLTPro-BlkIt",
                "HelveticaNeueLTPro-Cn",
                "HelveticaNeueLTPro-CnO",
                "HelveticaNeueLTPro-Ex",
                "HelveticaNeueLTPro-ExO",
                "HelveticaNeueLTPro-Hv",
                "HelveticaNeueLTPro-HvCn",
                "HelveticaNeueLTPro-HvCnO",
                "HelveticaNeueLTPro-HvEx",
                "HelveticaNeueLTPro-HvExO",
                "HelveticaNeueLTPro-HvIt",
                "HelveticaNeueLTPro-It",
                "HelveticaNeueLTPro-Lt",
                "HelveticaNeueLTPro-LtCn",
                "HelveticaNeueLTPro-LtCnO",
                "HelveticaNeueLTPro-LtEx",
                "HelveticaNeueLTPro-LtExO",
                "HelveticaNeueLTPro-LtIt",
                "HelveticaNeueLTPro-Md",
                "HelveticaNeueLTPro-MdCn",
                "HelveticaNeueLTPro-MdCnO",
                "HelveticaNeueLTPro-MdEx",
                "HelveticaNeueLTPro-MdExO",
                "HelveticaNeueLTPro-MdIt",
                "HelveticaNeueLTPro-Roman",
                "HelveticaNeueLTPro-Th",
                "HelveticaNeueLTPro-ThCn",
                "HelveticaNeueLTPro-ThCnO",
                "HelveticaNeueLTPro-ThEx",
                "HelveticaNeueLTPro-ThExO",
                "HelveticaNeueLTPro-ThIt",
                "HelveticaNeueLTPro-UltLt",
                "HelveticaNeueLTPro-UltLtCn",
                "HelveticaNeueLTPro-UltLtCnO",
                "HelveticaNeueLTPro-UltLtEx",
                "HelveticaNeueLTPro-UltLtExO",
                "HelveticaNeueLTPro-UltLtIt",
                "HelveticaNeueLTPro-XBlkCn",
                "HelveticaNeueLTPro-XBlkCnO",
                "HeroePro",
                "Heroliga Bold",
                "HeroligaBold",
                "HurmeGeometricSans1-Black",
                "HurmeGeometricSans2-Black",
                "HurmeGeometricSans2-Bold",
                "HurmeGeometricSans2-Light",
                "HurmeGeometricSans2-Regular",
                "HurmeGeometricSans3-Black",
                "HurmeGeometricSans3-Light",
                "HurmeGeometricSans3-Regular",
                "IntegralCF-BoldOblique",
                "IntroCondBlackFree",
                "JitzuSwash-Medium",
                "KGHAPPY",
                "Kondolar-Black",
                "Kondolar-Bold",
                "Kondolar-Italic",
                "Kondolar-Regular",
                "Laffayette_Comic_Pro",
                "LustScript",
                "Mahdi-Regular",
                "majalla",
                "majallab",
                "MarckScript-Regular",
                "MarkerFelt",
                "Mexcellent-Regular",
                "MinionPro-Regular",
                "Mohave-Light",
                "Montserrat-Black",
                "Montserrat-Bold",
                "Montserrat-ExtraBold",
                "Montserrat-Italic",
                "Montserrat-Light",
                "Montserrat-LightItalic",
                "Montserrat-Medium",
                "Montserrat-Regular",
                "Montserrat-SemiBold",
                "Mulish-Bold",
                "Mulish-ExtraBold",
                "Mulish-Italic-VariableFont_wght",
                "Mulish-VariableFont_wght",
                "NarzissProCy-Regular-Drops",
                "NarzissProCyrillic",
                "NarzissProCyrillicDrops-Bold",
                "NarzissProCyrillicDrops-Medium",
                "NarzissProCyrillicDrops",
                "Neo Sans Std Medium TR",
                "Noteworthy",
                "OnlyYouSexyBold",
                "Othelie-LineItalic",
                "PFDinTextCompPro-Bold",
                "PFDinTextCompPro-Regular",
                "PFDinTextCondPro-Bold",
                "PFDinTextCondPro-Light",
                "PFDinTextCondPro-LightItalic",
                "PFDinTextCondPro-Medium",
                "PFDinTextCondPro-MediumItalic",
                "PFDinTextCondPro-Regular",
                "PFDinTextCondPro-Thin",
                "PFDinTextCondPro-ThinItalic",
                "Pistoletto Free 400",
                "PlayfairDisplay-Bold",
                "PlayfairDisplay-BoldItalic",
                "PlayfairDisplay-Italic",
                "PlayfairDisplay-MediumItalic",
                "PlayfairDisplay-Regular",
                "PlayfairDisplay-SemiBold",
                "PlayfairDisplay-SemiBoldItalic",
                "Poppins-Black",
                "Poppins-Bold",
                "Poppins-Regular",
                "Raleway-Bold",
                "Raleway-Bold",
                "Raleway-BoldItalic",
                "Raleway-ExtraLight",
                "Raleway-Heavy",
                "Raleway-Italic",
                "Raleway-Medium",
                "Raleway-Regular",
                "Raleway-Regular",
                "Raneya",
                "RaptorV3Premium-Black",
                "RaptorV3Premium-Regular",
                "Roboto-Bold",
                "Scheherazade-Bold",
                "Scheherazade-Regular",
                "ScheherazadeRegOT",
                "SignPainter",
                "SteelfishRg-Regular",
                "Swis721BlkCnBT-Black",
                "Swis721BlkOulBT-Black",
                "SWISS721-Book-Cond",
                "SWISS721-Light",
                "SWZ721C",
                "Times New Roman Italic",
                "Times New Roman",
                "Times",
                "URWLatinoTOT-Bol",
                "URWLatinoTOT-BolIta",
                "URWLatinoTOT-Reg",
                "URWLatinoTOT-RegIta",
                "verdanab",
                "YakoutLinotypeLight-Bold",
                "YakoutLinotypeLight-Regular",
            ],
            fontSize: true,
            fontColor: true,
            hilite: true,
            fontFamily: true
        },
        format: { heading1: false, heading2: false, heading3: false, paragraph: true, clearFormatting: true, },
        indentOutdent: true,
        align: true,
        actions: false,
        undoredo: false,
        //maxWidth:"1024px"
    },
    'grapesjs-plugin-export': { /* options */ },
    'gjs-blocks-basic': {
        blocks: ['column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'image', 'video'],
    },
    'gjs-blocks-avance': {},
    'gjs-plugin-ckeditor': {

        position: 'left',
        floatSpacePinnedOffsetY: 20,


        options: {
            fontColor: {
                colors: [{
                    color: 'hsl(0, 0%, 0%)',
                    label: 'Black--'
                },
                {
                    color: 'hsl(0, 0%, 30%)',
                    label: 'Dim grey'
                },
                {
                    color: 'hsl(0, 0%, 60%)',
                    label: 'Grey'
                },
                {
                    color: 'hsl(0, 0%, 90%)',
                    label: 'Light grey'
                },
                {
                    color: 'hsl(0, 0%, 100%)',
                    label: 'White',
                    hasBorder: true
                },

                    // ...
                ]
            },
            toolbarGroups: [
                { name: 'document', groups: ['mode', 'document', 'doctools'] },
                { name: 'clipboard', groups: ['clipboard', 'undo'] },
                { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
                { name: 'forms', groups: ['forms'] },
                // '/',
                { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
                { name: 'links', groups: ['links'] },
                { name: 'insert', groups: ['insert'] },
                // '/',
                { name: 'styles', groups: ['styles'] },
                { name: 'colors', groups: ['colors'] },
                { name: 'tools', groups: ['tools'] },
                { name: 'others', groups: ['others'] },
                // { name: 'about', groups: [ 'about' ] }
            ]
        }
    }
}


export {
    Devices,
    Fonts,
    axios,
    qs,
    hekcss,
    ckEditor,
    editorTool,
    //ContacComponent,
    myRuler,
    blockAdvance,
    blocksBasic,
    myExport,
    grapesjs,
    React,
     createContext,
      useContext,
       useState ,
       mPlugin,
       mpOptions

}

